import React, { Component } from 'react';
import DesktopFooter from '../components/common/DesktopFooter';
import ReportPage from '../components/Reports/ReportPage';
import KrishakReport from '../components/Reports/KrishakReport';

class Reports extends Component {
    render() {
        return (
            <div>
                {/* <ReportPage/> */}
                <KrishakReport />
                <DesktopFooter />
            </div >
        )
    }
}

export default Reports